export const getAverage = (numbers, decimals = 2) => {
    const total = numbers.reduce((a, b) => a + b, 0);
    const averageGrade = total ? total / numbers.length : 0;

    return averageGrade.toFixed(decimals);
}